import format from 'date-fns/format';

import { processSessions } from '../../../database/processors';

export const CreateKey = currentStore => date => format(date, `YYYY-MM-DD[-${currentStore}]`);

export const CreateAPI = (api, date) => api.replace(/.json/, format(date, '/YYYY/MM/DD[.json]'));

const hasKey = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export const ProcessSessions = sessions =>
  processSessions(sessions).reduce((items, session) => {
    const key = format(session.start, 'YYYY-MM-DD');
    if (hasKey(items, key)) {
      items[key].push(session);
      return items;
    }
    return { ...items, [key]: [session] };
  }, {});

export const StoreSessions = (setSessions, sessions) =>
  Promise.all(Object.entries(sessions).map(([k, v]) => setSessions(v, v[0].start)));
